import { render, staticRenderFns } from "./ProfileVitalSignBodyMassFull.vue?vue&type=template&id=413b6b40&"
import script from "./ProfileVitalSignBodyMassFull.vue?vue&type=script&lang=js&"
export * from "./ProfileVitalSignBodyMassFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports